import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

export const LogoPreview = ({ logoUrl }) => {
  if (!logoUrl) return null;

  return (
    <Paper variant='outlined' sx={{ p: 2, my: 3, bgcolor: 'transparent' }}>
      <Typography variant='subtitle2' gutterBottom>
        Preview:
      </Typography>
      <Box
        sx={{
          position: 'relative',
          aspectRatio: '16/9',
          bgcolor: 'transparent',
          borderRadius: 1,
          overflow: 'hidden',
        }}
      >
        <Box
          component='img'
          src={logoUrl}
          alt='Logo preview'
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>
    </Paper>
  );
};
